export const placesToVisit = [
  {
    name: "Hanoi",
    url: [
      "https://www.willflyforfood.net/wp-content/uploads/2019/11/hanoi-travel-guide-cover.jpg",
      "https://media-cdn.tripadvisor.com/media/photo-m/1280/1b/33/f7/12/caption.jpg",
      "https://reviewvilla.vn/wp-content/uploads/2022/05/kinh-nghiem-du-lich-ha-noi-5-1024x577.jpg"
      

    ],
    id: 1,
    moreInfo: `
    Vietnam's capital is the frenetic heartbeat of the nation and a place that befuddles travelers as much as it charms them.

    The motorbike frenzy, pollution, and constant clamor of street vendors can get too much for some travelers, but if you want to dive into Vietnamese city life, Hanoi is the place to do it.
    
    The old town quarter has plenty of dilapidated charm on offer, while history fans should make a beeline here simply to see the bundle of excellent museums.
    
    The Vietnam Museum of Ethnology and Vietnam Fine Art Museum are both brilliant introductions to the diverse artistry of the country, while the Ho Chi Minh Mausoleum is an important tribute to the founder of modern Vietnam.`,
    description: "Vietnam's capital city is a blend of ancient and modern, known for its historic temples, vibrant street markets, and French colonial architecture.",
    thingsToDo: ["Explore the Old Quarter", "Visit Hoan Kiem Lake", "Experience Water Puppet Theatre"]
  },
  {
    name: "Ho Chi Minh City",
    id: 2,
    url: [
      "https://cdn1.img.sputniknews.vn/img/301/85/3018543_106:0:1813:1280_1920x0_80_0_0_7e8ef9c79247de20f96467b28258aa0d.jpg",
      "https://owa.bestprice.vn/images/articles/uploads/tat-tan-tat-cac-cho-lon-o-thanh-pho-ho-chi-minh-ban-nhat-dinh-nen-ghe-toi-mot-lan-5f4e1c24576f7.jpg",
      "https://cdn.tuoitrethudo.com.vn/stores/news_dataimages/2022/112022/08/14/bien-doi-khi-hau20221108144834.jpg?rt=20221108144840"
    ],
    moreInfo: `
    For big city fans, no visit to Vietnam is really complete without a visit to Ho Chi Minh City, the buzzing commercial hub of the country.

    The streets are an insane clog of motorbikes and cars, the restaurant and café scene is incredibly cosmopolitan, and the shopping is the best in the country.
    
    At its center is Dong Khoi, a relatively small and easily navigable central district, which holds most of the city's sights.
    
    Here, you'll find the HCMC Museum, with a brilliant collection of artifacts that weaves together the story of the city, and the grand Notre Dame Cathedral, built in the late 19th century.
    
    Check out the old district of Da Kao nearby for some of the best surviving examples of the city's French colonial architecture and also to visit the Jade Emperor Pagoda with its dazzling array of Buddhist and Taoist religious iconography.
    
    Afterwards, the History Museum is a must-do for history fans with stacks of relics on display from various archaeological sites.
    
    For many visitors, the two big-hitter tourist attractions not to miss are just a little out of the center, along Nguyen Thi Minh Khai Street. The Reunification Palace, then known as Independence Palace, was the residence for South Vietnam's president. It's chiefly famous as the spot where North Vietnam's tanks stopped on 30 April 1975, officially ending the war. It's a completely fascinating place to visit complete with 1960s furnishings still in situ.
    
    Nearby is the War Remnants Museum, which although very obviously biased, paints a disturbing picture of the brutality of war and the many atrocities committed by US Forces during their Vietnam campaign.`,
    description: "The bustling metropolis of the south offers a mix of skyscrapers, cultural landmarks, and energetic street life.",
    thingsToDo: ["Visit War Remnants Museum", "Stroll along Nguyen Hue Walking Street", "Explore Ben Thanh Market"]
  },
  {
    id:3,
    name: "Hoi An",
    url: [
      "https://touristjourney.com/wp-content/uploads/2020/05/Da-Nang-bridge-1024x682.jpg",
      "https://danangleisure.com/wp-content/uploads/2023/05/hoi-an-1680591517857660432696.jpeg",
      "https://www.onthegotours.com/blog/wp-content/uploads/2013/02/The-Japanese-Bridge-in-Hoi-An-Vietnam.jpg"
    ],
    moreInfo: `
    Beautiful Hoi An is the most atmospheric city in Vietnam, with bags of surviving historic architecture.

    The old town quarter is a joy to explore, packed to the brim with well-preserved merchant houses that hark back to Hoi An's trading center heyday of the 15th century, when the town was a major meeting point for Japanese and Chinese merchants who flocked here for the local silks.
    
    Plenty of the old merchant houses have been opened to the public, so you can get a taste of these times. The best is 17th-century Tan Ky House, with fascinating architectural and decorative elements.
    
    Hoi An's major symbol is the delightful Japanese Bridge at the western end of Tran Phu Street, while nearby, the Assembly Hall of the Fujian Chinese Congregation is the old town's most highly decorated temple.
    
    There are numerous small pagodas and museums dotted about town, but Hoi An's true charm is found in simply rambling the old town streets admiring the well-preserved facades.`,
    description: "This charming ancient town is famous for its well-preserved architecture, lantern-lit streets, and artistic community.",
    thingsToDo: ["Walk through Ancient Town", "Visit Japanese Covered Bridge", "Take a cooking class"]
  },
  {
    id: 4, 
    name: "Ha Long Bay",
    url: [
      "https://images2.thanhnien.vn/528068263637045248/2023/3/27/edit-cauduonghlzing2-1679906556196194353586.png",
      "https://media-cdn-v2.laodong.vn/Storage/NewsPortal/2022/9/14/1093152/Halongbay.jpg",
      "https://media-cdn.tripadvisor.com/media/photo-s/17/2e/76/55/d-ng-phong-nha-la-danh.jpg"
    ],
    moreInfo: `
    The karst seascape of Halong Bay is one of the best places to visit in the world for spellbinding sea views and is a UNESCO World Heritage Site.

    Thousands of limestone islands sit within this bay in the Gulf of Tonkin, eroded into jagged pinnacles by wind and water action over millennia.
    
    With the bay's scenery best seen by boat, this is prime cruising territory. Opt for at least an overnight tour to see Halong Bay's iconic views as a day trip doesn't do it justice.
    
    There are plenty of caves in the bay that can be entered including the Hang Sung Sot, with three mammoth caverns, and the Hang Dao Go, with superbly weird stalagmites and stalactites. For most people though, the highlight is simply cruising amid the karsts and soaking up the changing scenery of pinnacles as you pass by.`,
    description: "A UNESCO World Heritage Site, Ha Long Bay is renowned for its emerald waters and thousands of limestone karsts.",
    thingsToDo: ["Take a cruise through the bay", "Explore Sung Sot Cave", "Go kayaking"]
  },
  {
    id: 5,
    name: "Sapa",
    url: [
      "https://s39023.pcdn.co/wp-content/uploads/2020/03/Things-To-Do-In-Sapa-Where-Are-Those-Morgans.jpg.optimal.jpg",
      "https://images.travelandleisureasia.com/wp-content/uploads/sites/2/2020/01/Sapa-Valley-feature.jpg",
      "https://res.klook.com/image/upload/fl_lossy.progressive,w_800,c_fill,q_85/destination/gz7tgpplajttevacsz4v.jpg"
    ],
    moreInfo: `
    The verdant rice field countryside surrounding Sapa, bordered by the jagged peaks of the Hoang Lien Mountains (often still known by their French colonial era name of the Tonkinese Alps), are home to Vietnam's most beautiful rural vistas.

    The deep valleys here are home to a diverse mix of the country's ethnic minorities, including the Hmong, Giay, and Red Dzao people, while the rippling hills are terraced with rice fields and overlooked by the country's tallest peak, Fansipan Mountain.
    
    This is the top trekking destination in Vietnam with oodles of options to trek or day hike between tiny villages and experience the staggering mountain views.
    
    Sapa itself is the main base here - an old hill station and now a bustling and forever growing tourist center that is a stark contrast to the sumptuous tranquil countryside right on its doorstep.`,
    description: "Nestled in the northern mountains, Sapa offers stunning terraced rice fields, ethnic hill tribe cultures, and breathtaking landscapes.",
    thingsToDo: ["Trek to Cat Cat village", "Admire Fansipan Mountain", "Shop for local handicrafts"]
  },
  {
    id: 6,
    name: "Nha Trang",
    url: [
      "https://a.cdn-hotels.com/gdcs/production43/d1331/261bab74-5edd-4f18-97c1-e945ebee1956.jpg",
      "https://content.r9cdn.net/rimg/dimg/3c/08/1a8e1f7d-city-46568-169828ca9a6.jpg?width=1366&height=768&xhint=1577&yhint=769&crop=true",
      "https://image.nhandan.vn/w800/Uploaded/2023/jaijae/2023_02_14/a2-6292.jpg"
    ],
    moreInfo: `
    For sandy fun in Vietnam, Nha Trang is king. The well-maintained beach trundles for six kilometers along the shoreline of central Nha Trang city and during summer is jam-packed with local families on vacation, as well as foreign visitors.

    There is excellent swimming here with designated swimming areas and manicured lounging areas that make this a great option for relaxing days soaking up the sun and sand.
    
    If you do get bored of sunbathing, the ancient Po Nagar Cham Towers are just to the north across the Xom Bong Bridge and have been used as a place of worship here since at least the 7th century (with some historians saying the site itself has been a place of active worship since much earlier).
    
    There is also an excellent museum dedicated to the work of Alexandre Yersin who discovered the cause of the bubonic plague and founded Nha Trang's Pasteur Institute (which still carries out vaccination programs in Vietnam today).`,
    description: "Known for its beautiful beaches and vibrant nightlife, Nha Trang offers water sports, marine life, and relaxation.",
    thingsToDo: ["Visit Vinpearl Land", "Relax on Nha Trang Beach", "Go diving or snorkeling"]
  },
  {
    id: 7,
    name: "Da Nang",
    url: [
      "https://a.cdn-hotels.com/gdcs/production126/d1337/a4fd6b39-16b6-4230-bcf1-155a0d9a72c1.jpg",
      "https://a.cdn-hotels.com/gdcs/production169/d706/0f0aac2e-d76c-491a-bdb7-8782ab164670.jpg",
      "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/77000/77654-Da-Nang.jpg"
    ],
    moreInfo: `
    With broad beaches, fantastic street food, the fabled Hai Van Pass, and a growing collection of cafes, restaurants, and bars, it’s no wonder the residents of Da Nang sport some of the broadest smiles in the country. The warm sands of My Khe Beach sweep south from the mountainous Son Tra Peninsula. Da Nang hosts some of Vietnam's top luxury resorts, but much of the beach still belongs to the people who make it their playground, gym, and source of livelihood.`,
    description: "A coastal city with a modern vibe, Da Nang is famous for its pristine beaches, the Marble Mountains, and the iconic Golden Bridge.",
    thingsToDo: ["Explore Marble Mountains", "Relax on My Khe Beach", "Visit Ba Na Hills"]
  },
  {
    id: 8,
    name: "Mui Ne",
    url: [
      "https://thesologlobetrotter.com/wp-content/uploads/2018/01/sand-dunes-4122263_1280-2-scaled.jpg",
      "https://vcdn1-dulich.vnecdn.net/2022/07/29/muine-1659059278-5222-16590594-9037-6291-1659068912.jpg?w=1200&h=0&q=100&dpr=1&fit=crop&s=tzc1fgx29gobuD3qWKJfgA",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgmmjHuEElT6d2zbSf0roPmsvVOqZMenJwhQ&usqp=CAU"
    ],
    moreInfo: `
    Once a sleepy coastal fishing town, Mui Né has developed into a beautiful beach resort town and a prime destination for windsurfing, sailing, and kitesurfing.

    Compared to other beach destinations in Vietnam, however, Mui Né remains relatively unknown - and this means pristine beaches and a quiet retreat for most of the year.
    One of Mui Né's most unique attractions is the natural Red Sand Dunes just outside town, where visitors can practice sand-sledding or rent dune buggies for a more adrenaline-charged experience.

    Tucked away between nearby fishing villages and towering orange limestone formations, there's the fairy stream, a slow-moving warm stream that almost feels like a walkway because it's so shallow - follow it to the end to reach a waterfall.

    For those wishing to explore beyond the coastline, there's also the ruins of the Po Shanu Cham Towers - remnants of the Cham Empire that dominated the area many centuries ago.`,
    description: "This coastal town is famous for its unique sand dunes, water sports, and relaxed atmosphere.",
    thingsToDo: ["Visit Red Sand Dunes", "Take a jeep tour to White Sand Dunes", "Enjoy kite surfing"]
  },
  {
    id: 9,
    name: "Phu Quoc Island",
    url: [
      "https://vcdn1-english.vnecdn.net/2021/01/14/PQ-1610609299.jpg?w=1200&h=0&q=100&dpr=1&fit=crop&s=QPETYkJlN9eKaDJxPdWGSg",
      "https://triple7travel.vn/upload/product/dao-ngoc-pq-4459.png",
      "https://vcdn1-dulich.vnecdn.net/2022/04/08/Phu-Quoc-9226-1649405350.jpg?w=0&h=0&q=100&dpr=1&fit=crop&s=h51OqoZGtadQj3WYCS8cig"
    ],
    moreInfo: `
    Sitting 45 kilometers off the southern coast of the country, in the Gulf of Thailand, Phu Quoc is a densely forested island, speckled by sweeps of white-sand beach that attract plenty of sunseekers during the winter dry season.

    Dry season (November to May) is also when the island's underwater and on-the-water tourism attractions spring into action, with plenty of dive sites in the waters just offshore, as well as opportunities for snorkeling, kayaking, and boat trips.
    
    Many of the main boat excursions head to the An Thoi Islands, just to the south of Phu Quoc, which is home to the best snorkeling in the area.
    
    Off the water, the Phu Quoc cable-car provides bird's-eye views for eight kilometers, soaring over the seascape and islands, all the way from Phu Quoc to the island of Hon Thom in the An Thoi Islands.
    
    Phu Quac is accessed by plane or regular ferries from the mainland towns of Rach Gia and Ha Tien. As Ha Tien lies very close to the southern border crossing with Cambodia, the island is a popular first (or last) stop-off in Vietnam for overland travelers.`,
    description: "Vietnam's largest island offers stunning beaches, clear waters, and a growing range of luxury resorts.",
    food: ["Herring Salad", "Goi Ca Trich"],
    thingsToDo: ["Relax on Sao Beach", "Explore Dinh Cau Night Market", "Visit Vinpearl Safari"]
  },
  {
    id: 10, 
    name: "Hue",
    url: [
      "https://www.travellens.co/content/images/2021/10/hue-vietnam.jpg",
      "https://ahanetworkvietnam.files.wordpress.com/2021/09/huetourism_bang-lang-co-do-hue.jpg?w=1280",
      "https://www.nomadasaurus.com/wp-content/uploads/2020/01/khai_dinh_tomb_worldforagirl.jpg"
    ],
    moreInfo: `
    One of Vietnam's most historic towns, Hue is packed to the brim with relics from the reign of the 19th-century Nguyen emperors.

    Sitting along the banks of the gorgeous Perfume River, the Imperial Enclosure is a huge site set within walls that sprawl for 2.5 kilometers.
    
    While touring the grounds check out the gorgeous Ngo Mon Gate, the Thai Hoa Palace with its finely lacquered interior detailing, the Dien Tho Residence where the Queen Mothers would live, and the Halls of Mandarins with its preserved ceiling murals.
    
    A dazzling number of historic sites lie outside the Imperial Enclosure walls as well.
    
    One of the nicest ways of visiting a collection of outlying sites is by taking a riverboat cruise on the Perfume River. A day cruise can take you to visit several royal tombs along with some pagodas.
    
    If you're short on time, the best tomb to visit is the Tomb of Tu Doc and the most important pagoda in the area is the Thien Mu Pagoda, with its tower that soars for 21 meters high.`,
    description: "Once the imperial capital, Hue is known for its historical citadel, royal tombs, and tranquil Perfume River.",
    thingsToDo: ["Explore the Imperial City", "Visit Thien Mu Pagoda", "Cruise along Perfume River"]
  },
  {
    id: 11, 
    name: "Phong Nha-Ke Bang National Park",
    url: [
      "https://vietnamdiscovery.com/wp-content/uploads/2019/11/Phong-nha-ke-bang-national-park.jpg",
      "https://assets.traveltriangle.com/blog/wp-content/uploads/2018/11/All-About-The-Phong-Nha-Cave.jpg",
      "https://vietnamdiscovery.com/wp-content/uploads/2019/11/Cultural-Heritage-of-Phong-Nha-Ke-Bang.jpg"
    ],
    moreInfo: `
    One of the best places to visit in Vietnam for caving, World Heritage-listed Phong Nha-Ke Bang National Park is a dramatic karst mountain formation honeycombed with huge caverns, which are home to superb stalactite and stalagmite displays.

    The most popular destination within the park is the Paradise Cave, which extends for a staggering 31 kilometers below ground.
    
    The yawning caverns here are truly spectacular. Tu Lan Cave is a "wet cave," and a visit here includes swimming through the cave-systems river.
    
    The other most popular excursion is to the Phong Nha Caves, where the interior is accessed by boat.
    
    You can access Phong Nha-Ke Bang National Park from Son Trach.`,
    description: "A UNESCO-listed site, this park features the world's largest cave systems and stunning karst landscapes.",
    thingsToDo: ["Explore Phong Nha Cave", "Discover Son Doong Cave", "Visit Paradise Cave"]
  },
  {
    id: 12,
    name: "Mekong Delta",
    url: [
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLuRTVeaAG2erKcarqrQ3ZUNQ2QUx7IRxyoCz3RHKHS7AUuzrHP97hSM0kiKfG5dkoI34&usqp=CAU",
      "https://media.audleytravel.com/-/media/images/home/southeast-asia/vietnam/places/istock_77224427_fishing_mekong_delta_3000x1000.jpg?q=79&w=1920&h=640",
      "https://vietnamdiscovery.com/wp-content/uploads/thumbnail/Cai-Rang-Floating-Market-Featured-pg6c3aovt98gcyui67udx8g5slbd0he52db4wld3tc.jpg"
    ],
    moreInfo: `
    The far south of Vietnam is where the mighty Mekong River finally finds its way to the sea in a maze of waterways that crisscross the floodplain.

    Incredibly lush, with paddy field vistas and mangroves, and full of local life, with chaotic floating markets to explore by boat, the delta is one of the most interesting regions for travelers to discover.
    
    Can Tho is the most popular town to use as a base, as it's close to the floating markets of Phong Dien and Cai Rang, while boat trips from Ca Mau allow you to explore the U Minh Mangrove Forest and Cau Mau Nature Reserve.`,
    description: "The 'Rice Bowl' of Vietnam, the Mekong Delta offers riverine landscapes, floating markets, and lush fruit orchards.",
    thingsToDo: ["Cruise along the Mekong River", "Visit Cai Rang Floating Market", "Experience homestays"]
  },
  
  {
    id: 13,
    name: "Dalat",
    url: [
      "https://media.tacdn.com/media/attractions-splice-spp-674x446/0f/84/f2/8e.jpg",
      "https://thereshegoesagain.org/wp-content/uploads/2021/02/ClayTunnels_Dalat_09.jpg",
      "https://nld.mediacdn.vn/291774122806476800/2023/4/30/sap-nhap-1-1682817100311843996433.jpg"
    ],
    moreInfo: `
    Dalat or Da Lat is the capital city of Lam Dong province, Vietnam. Da Lat is the City of Flowers and honeymooners with lovely French villas, the fresh air, the beautiful waterfalls and gorgeous lakes sits in a lush and green valley of postcard beauty. 

    In the late nineteenth century, a Swiss man with French nationality was Alexandre Yersin, at the request of the French authorities at that time, explored the Central Highlands and reached the Lang Biang plateau to lead to the formation of the flower city today.
    Da Lat has been calling as Vietnam’s “vegetable garden” due to its year-round cool weather. Da Lat supplies temperate agriculture products for all over Vietnam. Indeed, Dalat is renowned for its orchids, roses, vegetables, and fruits. There are nascent wine-making and flower-growing industries in the region of Asia (main flower consuming market is Singapore, Hongkong, Korea, Japan).    `,
    description: "Known as the 'City of Eternal Spring,' Dalat offers a cool climate, flower gardens, and charming French architecture.",
    thingsToDo: ["Explore Crazy House", "Visit Flower Park", "Take a cable car to Truc Lam Pagoda"]
  },
  {
    id: 14,
    name: "Con Dao Islands",
    url: [
      "https://vietnamtrips.com/files/photos/category135/con-dao-island-title-photo.jpg",
      "https://static-images.vnncdn.net/files/publish/2022/9/2/beautiful-con-dao-island-seen-from-above-15a09c6184ef41b59b21f1ea17a45bda.jpg",
      "https://statics.vinpearl.com/con-dao-national-park-1_1687674238.jpg"
    ],
    moreInfo: `
    This remote island group lies around 160 kilometers offshore in the South China Sea and is renowned among divers as one of the best places to visit in the country, both for the variety of sea life and for the coral reefs.

    Much of the Con Dao Islands, and the surrounding water, is a protected wilderness area, with the island shores home to nesting turtles, and dense forest still covering the island interiors.
    
    The main island, and prime base for visitors with all the accommodation and things to do, is Con Son Island, which has sweeps of sand strung out across its coast that attract beachgoers looking for a relaxed sun-soaked getaway, as well as divers.
    
    Even if you're here mostly for the beach, make sure to explore the historic sites of Con Son Town (the island's only settlement) including Phu Hai Prison, Bao Tang Con Dao Museum, and the prison known as the Tiger Cages, which document the dark history of this isolated island group.
    
    Con Son's remote position led to the island being used to incarcerate political prisoners during the era Vietnam was occupied by French colonial forces, and later by both the South Vietnamese government and the occupying American forces.
    
    Preserved sites including Phu Hai Prison and the prison cages used by the US forces, known as the Tiger Cages, along with Con Son Town's Bao Tang Con Dao Museum, do an excellent job of documenting this history for visitors.
    
    Access to Con Son Island is either by flight from Ho Chi Minh City or by ferry from the coastal city of Vung Tau.`,
    description: "An archipelago with stunning beaches, coral reefs, and a tragic history as a former prison complex.",
    thingsToDo: ["Relax on untouched beaches", "Explore Con Dao Prison", "Go snorkeling or diving"]
  },
  {
    id: 15,
    name: "Cao Bang",
    url: [
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/13/d3/4a/fe/angel-eye-mountain.jpg?w=700&h=-1&s=1",
      "https://media.tacdn.com/media/attractions-splice-spp-674x446/0f/ef/c6/68.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBciJNNMhRPU7fD4YpZJiBFbOdsVaV5HEeow&usqp=CAU"
    ],
    moreInfo: `
    Cao Bang is an immensely beautiful, sparsely populated frontier region of North Vietnam. This mountainous expanse sits on the northeast border with China and is home to many ethnic minority communities. Although the Ban Gioc waterfalls have become a popular attraction, this region is often overlooked by tourists which has meant its unique beauty and culture has been well preserved. The landscape here is typified by jagged mountains carpeted in thick vegetation, sporadic rice paddies and thin winding roads. Typically the Vietnamese populations tended to avoid mountainous regions in favour of the better farmland in low-lying, flat areas. This meant that these remote and hilly areas were inhabited mainly by the ethnic minority communities and this is still largely the case in Cao Bang. The main groups living in the region are the Nung, Dao, Tay and H'mong. In April, 2018, the stunning natural beauty of the region was recognized when UNESCO made the decision to include Cao Bang in their Global Geoparks Network, making it Vietnam’s second entry on the list.`,
    description: "Located in the far north, Cao Bang boasts dramatic landscapes, waterfalls, and the stunning Ban Gioc Waterfall.",
    thingsToDo: ["Visit Ban Gioc Waterfall", "Explore Pac Bo Cave", "Hike to Phia Oac-Phia Den National Park"]
  },
  {
    id: 16,
    name: "Cat Ba Island",
    url: [
      "https://authentiktravel.com/media/ckeditor/cat-ba-beach-in-holiday.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBkVOE7wvguXZNrNL3T7wpNJAmJ8uwU69XsQ&usqp=CAU",
      "https://www.visithalongbay.com/media/cache/4f/e0/4fe0872d5d118ea5f86eef25e12d05cf.jpg"
    ],
    moreInfo: `
    One of Vietnam's major centers for activities and adventure travel attractions, Cat Ba Island sits on the western edge of Halong Bay.

    This is the best place to visit if you want to organize cruises and kayaking trips in Lan Ha Bay, which lies off Cat Ba's southern coast. Lan Ha Bay is a less visited seascape of karst islets and outcrops that makes for a quieter alternative to Halong Bay.
    
    Off the water, much of Cat Ba's dense jungle interior is part of Cat Ba National Park, where hikers can spot plentiful birdlife, as well as animals such as macaques.
    
    For many visitors, though, Cat Ba is all about climbing opportunities. Climbing excursions here utilize both the island's limestone cliffs and Lan Ha Bay's outcrops, providing experiences to suit both complete climbing beginners and experienced climbers.`,
    description: "The largest island in Halong Bay, Cat Ba offers beaches, hiking trails, and proximity to Lan Ha Bay.",
    thingsToDo: ["Relax on Cat Co Beaches", "Hike in Cat Ba National Park", "Explore Lan Ha Bay"]
  }
];

export const foodAndDestinations = [
{
  id: 1,
  name: "Bun Cha",
  url: [
      "https://culturephamtravel.com/wp-content/uploads/2022/09/best-bun-cha-hanoi-culture-pham-travel-2-1024x769.jpg",
      "https://www.lasinfoniadelreyhotel.com/img/gallery/bun_cha_content.jpg",
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTZWv2C1i62pp09pFM6QZ0XGAcTzEMhib7UsJTK0D_cn5swcj7ksyAr-IN8kidZy8SopA&usqp=CAU"
    ],
  places: ["Hanoi", "Hai Phong"]
},
{
  id: 2,
  name: "Pho",
  url: [
      "https://upload.wikimedia.org/wikipedia/commons/5/53/Pho-Beef-Noodles-2008.jpg",
      "https://bloximages.newyork1.vip.townnews.com/tulsaworld.com/content/tncms/assets/v3/editorial/d/de/dde04cd2-4088-5ef0-9577-ab703b43991d/524d8a5e8ad51.image.jpg",
      "https://helenrecipes.com/wp-content/uploads/2022/05/size-slide-show-23-1.png"
    ],
  places: ["Hanoi", "Ho Chi Minh City"]
},
{
  id: 3,
  name: "Cao Lau",
  url: [
    "https://img.tastykitchen.vn/crop/1200x628/2022/06/03/cao-lau-hoi-an-06-52b7.jpg",
    "https://dulichkhampha24.com/wp-content/uploads/2021/03/cao-lau-hoi-an-1-2.jpg",
    "https://www.hoidaubepaau.com/wp-content/uploads/2017/11/cao-lau-hoi-an.jpg"
  ],
  places: ["Hoi An"]
},
{
  id: 4,
  name: "Banh Mi",
  url: [
    "https://afamilycdn.com/thumb_w/640/150157425591193600/2020/4/13/artboard-3-1586758061634835492767-0-0-500-800-crop-15867581193952107008613.png",
    "https://asiapaths.com/wp-content/uploads/2023/04/cach-lam-banh-mi-heo-quay-thom-ngon-cho-bua-sang-dinh-duong-202201041047079624-2.jpg",
    "https://cdnmedia.baotintuc.vn/2018/01/02/18/09/banhmii.jpg"
  ],
  places: ["Ho Chi Minh City", "Hoi An"]
},
{
  id: 5,
  name: "Mi Quang",
  url: [
    "https://vietnamtrips.com/files/photos/article1276/mi-quang-noodle.jpg",
    "https://static.vinwonders.com/2022/12/mi-quang-6.jpg",
    "https://tastytouch.net/wp-content/uploads/2022/03/mi-quang-ga-500x400.jpg"
  ],
  places: ["Da Nang"]
},
{
  id: 6, 
  name: "Bun Bo Hue",
  url: [
    "https://whattocooktoday.com/wp-content/uploads/2023/03/bbh-1.jpg",
    "https://pupswithchopsticks.com/wp-content/uploads/bun-bo-hue-done2.jpg",
    "https://i1.wp.com/seonkyounglongest.com/wp-content/uploads/2017/08/Bun-Bo-Hue-45.jpg?resize=1000%2C562"
  ],
  places: ["Hue"]
},
{
  id: 7,
  name: "Com tam",
  url: [
    "https://images.foody.vn/res/g18/171840/prof/s/file_restaurant_photo_j59m_16363-6892d5af-211108221755.jpg",
    "https://images.foody.vn/res/g106/1055065/prof/s1242x600/foody-upload-api-foody-mobile-com-thu-201111093617.jpg",
    "https://canbepnho.com/wp-content/uploads/2023/02/Com-tam-Sa-Bi-Chuong-Da-Lat-3.jpg"
  ],
  places: ["Ho Chi Minh City"]
},
{
  id: 8,
  name: "Goi Cuon",
  url: [
    "https://www.wokandkin.com/wp-content/uploads/2021/04/Vietnamese-Rice-Paper-Rolls-Close-Up-saved-for-web.png",
    "https://culinessa.com/wp-content/uploads/2014/01/IMG_0956-e1391164259929-1024x1024.jpg",
    "https://images.squarespace-cdn.com/content/v1/52d3fafee4b03c7eaedee15f/1569626481609-7Z4AZMMFRLRFZ8DJC8DB/118.jpg"
  ],
  places: ["Various"]
},
{
  id: 9,
  name: "Bun Rieu",
  url: [
    "https://i2.wp.com/seonkyounglongest.com/wp-content/uploads/2018/06/Bun-Rieu-07.jpg?fit=1300%2C731&ssl=1",
    "https://i0.wp.com/katiestestkitchen.com/wp-content/uploads/2019/04/20190409_125912-2501224696-1554836206940.jpg?fit=3744%2C2853&ssl=1",
    "https://cookwithchung.com/wp-content/uploads/2022/11/Bun-Rieu-Vietnamese-Crab-Noodle-Soup.jpg"
  ],
  places: ["Hanoi", "Hai Phong"]
},
{
  id: 10,
  name: "Banh Xeo",
  url: [
    "https://vietnamnomad.com/wp-content/uploads/2022/07/Banh-Xeo-A-guide-to-Vietnamese-Pancakes-Vietnamnomad.jpg",
    "https://img.taste.com.au/hegWu1Xh/taste/2016/11/banh-xeo-crispy-pancakes-77516-1.jpeg",
    "https://rasamalaysia.com/wp-content/uploads/2009/11/banh_xeo-1.jpg"
  ],
  places: ["Ho Chi Minh City", "Da Nang"]
},
{
  id: 11,
  name: "Bun Thit Nuong",
  url: [
    "https://carmyy.com/wp-content/uploads/2021/10/bun-thit-nuong-9.jpg",
    "https://twoplaidaprons.com/wp-content/uploads/2022/08/side-shot-bun-thit-nuong-thumbnail.jpg",
    "https://recipes.net/wp-content/uploads/2021/09/bun-thit-nuong-recipe.jpg"
  ],
  places: ["Ho Chi Minh City"]
},
{
  id: 12,
  name: "Nem Nuong",
  url: [
    "https://www.huongnghiepaau.com/wp-content/uploads/2019/01/nem-nuong-mien-tay620x400.jpg",
    "https://cdn.tgdd.vn/2021/09/CookRecipe/Avatar/nem-nuong-nha-trang-bang-noi-chien-khong-dau-thumbnail.jpg",
    "https://i.ytimg.com/vi/Bmx6GWCWNjM/maxresdefault.jpg"
  ],
  places: ["Nha Trang"]
},
{
  id: 13,
  name: "Hu Tieu",
  url: [
    "https://vietnamnomad.com/wp-content/uploads/2022/09/The-origin-of-hu-tieu-Vietnamnomad.jpg",
    "https://www.mxchronicles.blog/wp-content/uploads/2021/03/hutieukho-16-1440x960.jpg",
    "https://yummyvietnam.net/wp-content/uploads/2019/05/Authentic-hu-tieu-nam-vang-recipe-Phnom-Penh-Noodle-Soup-1.jpg"
  ],
  places: ["Mekong Delta"]
},
{
  id: 14,
  name: "Banh Khot",
  url: [
    "https://daylambanh.edu.vn/wp-content/uploads/2019/12/banh-khot-mien-nam-hap-dan-600x400.jpg",
    "https://www.wokandkin.com/wp-content/uploads/2021/02/Banh-Khot-Close-Up-saved-for-web.png",
    "https://foodisafourletterword.com/wp-content/uploads/2020/12/Vietnamese_Crispy_Savory_Shrimp_Pancakes_Recipe_Banh_Khot_side.jpg",
  ],
  places: ["Vung Tau", "Ho Chi Minh City"]
},
{
  id: 15,
  name: "Bun Mam",
  url: [
    "https://i0.wp.com/www.wokandkin.com/wp-content/uploads/2020/06/Bun-Mam-Angled-saved-for-web.png?resize=600%2C900&ssl=1",
    "https://tastytouch.net/wp-content/uploads/2022/03/cach-nau-bun-mam-thom-ngon-kho-cuong-khong-khac-gi-ngoai-hang-avt-1200x676-1.jpg",
    "https://www.vietnamlocalguide.com/uploads/content/Travel_News/bun-mam-1.jpg"
  ],
  places: ["Mekong Delta"]
},
{
  id: 16,
  name: "Bun Ca",
  url: [
    "https://vietnamnomad.com/wp-content/uploads/2022/12/Bun-Ca-Nha-Trang-Vietnamnomad.jpg",
    "https://vietnamtimes.org.vn/stores/news_dataimages/dieuhuongvnt/062021/25/17/3046_2.png?rt=20210625173047",
    "https://cdn.tgdd.vn/Files/2020/04/03/1246339/cach-nau-bun-ca-ha-noi-thom-ngon-chuan-vi-khong-ta-14-760x367.jpg"
  ],
  places: ["Mekong Delta"]
},
{
  id: 17,
  name: "Nem Ran",
  url: [
    "https://img.taste.com.au/vPWXXadt/taste/2016/11/nem-ran-north-vietnamese-spring-rolls-21763-1.jpeg",
    "https://www.allrecipes.com/thmb/3aFPnkHifpku4TQ0Pq5VpgMEKRs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/245343_AuthenticVietnameseSpringRolls_ddmf_01_4x3_JD_5538-f1bbd0a7f8924959a2498f19ed93bc95.jpg",
    "https://www.vietnamonline.com/media/uploads/froala_editor/images/VNO_NEM.jpg"
  ],
  places: ["Hanoi", "Hue"]
},
{
  id: 18,
  name: "Bun Moc",
  url: [
    "https://yummyvietnam.net/wp-content/uploads/2017/02/Vietnamese-bun-moc-recipe-How-to-make-the-best-bun-moc12.png",
    "https://4.bp.blogspot.com/-yJWalmG7vcU/UhbViFzpteI/AAAAAAAACXY/k_JmUbwqmJU/s1600/DSC09485.JPG",
    "https://yelohtx.com/wp-content/uploads/2023/05/What-to-serve-with-bun-moc-1024x1024.jpg"
  ],
  places: ["Hanoi"]
},
{
  id: 19,
  name: "Bun Oc",
  url: [
    "https://www.luxurycruisemekong.com/wp-content/uploads/2017/01/Snail-noode-in-Mekong.jpg",
    "https://images.squarespace-cdn.com/content/v1/52d3fafee4b03c7eaedee15f/1489034451088-IU8KJK26XUJRGQY1X04M/Vietnamese+Snail+Noodle+Soup+Bun+Oc+Recipe",
    "https://ezvietnamesecuisine.com/wp-content/uploads/2019/09/bun_oc_2-1.jpg"
  ],
  places: ["Hanoi"]
},
{
  id: 20,
  name: "Banh Canh",
  url: [
    "https://images.squarespace-cdn.com/content/v1/52d3fafee4b03c7eaedee15f/1453873042236-8B0HJ403NLIOV5QDVRAN/banh+canh+vietnamese+thick+noodle+soup+recipe",
    "https://giavi.net/wp-content/uploads/2022/06/banh-canh-2.jpg",
    "https://ghiennauan.info/wp-content/uploads/2022/06/cach-nau-banh-canh-bot-loc.jpg"
  ],
  places: ["Various"]
},
{
  id: 21,
  name: "Goat Curry",
  url: [
    "https://i.ytimg.com/vi/aYn1edNDN0M/maxresdefault.jpg",
    "https://trivietphat.net/wp-content/uploads/2022/11/cach-nau-ca-ri-de-3.webp",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqWuksxlsKdJgB7R8hGh6ASeMQwK5MhqO0CA&usqp=CAU"
  ],
  places: ["Mui Ne"]
},
{
  id: 22,
  name: "Chao Long",
  url: [
    "https://images.foody.vn/res/g25/245020/prof/s576x330/foody-mobile-foody-chao-long-hai--594-636014051026334282.jpg",
    "https://cdn.tgdd.vn/Files/2017/03/23/964106/cach-nau-chao-long-thom-ngon-sanh-ngang-hang-quan-202208261651597182.jpg",
    "https://diadiemlongkhanh.cdn.vccloud.vn/static/images/2022/06/08/ee1023df-7261-4b67-b939-9aef34e0d33e-image.jpeg"
  ],
  places: ["Can Tho"]
},

{
  id: 23,
  name: "Mi Vit Tiem",
  url: [
    "https://delightfulplate.com/wp-content/uploads/2020/03/Vietnamese-Duck-Noodle-Soup-Mi-Vit-Tiem-1.jpg",
    "https://4.bp.blogspot.com/-x5GJ5urphx0/UUd8Bzg9IuI/AAAAAAAABso/MKsIMcp8SrQ/s1600/IMG_1268.JPG",
    "https://ezvietnamesecuisine.com/wp-content/uploads/2019/09/roasted20duck20with20egg20noodle20soup20recipe20mc3ac20ve1bb8bt20tie1bb81m.png"
  ],
  places: ["Hue"]
},
{
  id: 24,
  name: "Bo La Lot",
  url: [
    "https://d13jio720g7qcs.cloudfront.net/images/guides/origin/5f62d2a6e8313.jpg",
    "https://i.ytimg.com/vi/Zf2O46_0fJU/maxresdefault.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-wQwVNcYrCEs6NmSuGK0cvjceHRNrD4qoLg&usqp=CAU"
  ],
  places: ["Ho Chi Minh City", "Hue"]
},
{ id: 25,
  name: "Bun Dau Mam Tom",
  url: [
    "https://vietnamnomad.com/wp-content/uploads/2023/05/What-is-bun-dau-mam-tom.jpg",
    "https://d13jio720g7qcs.cloudfront.net/images/guides/origin/5f101844ed29f.jpg",
    "https://d13jio720g7qcs.cloudfront.net/images/guides/origin/5f101bf45e83f.jpg"
  ],
  places: ["Hanoi"]
},
{
  id: 26,
  name: "Banh Tom",
  url: [
    "https://www.tasteatlas.com/images/dishes/70b363b42c2848b5b60cf3f328c4aba0.jpg",
    "https://www.huongnghiepaau.com/wp-content/uploads/2019/10/banh-tom-ho-tay-hap-dan.jpg",
    "https://maicookbook.com/wp-content/uploads/2021/11/maicookbook_banh_tom_prawn_fritters_1-1160x1450.jpg"
  ],
  places: ["Hanoi", "Hue"]
},
{
  id: 27,
  name: "Banh Da Cua",
  url: [
    "https://cdn.tgdd.vn/Files/2020/01/14/1231533/cach-nau-banh-da-cua-ngon-dung-chuan-vi-hai-phong-17.jpg",
    "https://giadungthongminhvn.com/Systems/2021/06/08/doi-bua-voi-banh-da-cua-tu-lam-tai-nha.jpg",
    "https://bepxua.vn/wp-content/uploads/2021/05/banh-da-cua-hai-phong.jpg"
  ],
  places: ["Hai Phong"]
},
{
  id: 28,
  name: "Bun Chao Tom",
  url: [
    "https://delightfulplate.com/wp-content/uploads/2020/06/Vietnamese-Shrimp-on-Sticks-Chao-Tom.jpg",
    "https://i0.wp.com/www.wokandkin.com/wp-content/uploads/2020/05/Sugarcane-Prawns-Close-Up-saved-for-web.png?fit=600%2C900&ssl=1",
    "https://miphosongvu.com/2015/wp-content/uploads/2012/03/song-vu-V12-bun-thit-nuong-chao-tom-grilled-pork-.jpg"
  ],
  places: ["Hue"]
},
{
  id: 29,
  name: "Cha Ca",
  url: [
    "https://runawayrice.com/wp-content/uploads/2015/04/Fish-Cakes.jpg",
    "https://lh3.googleusercontent.com/0LuXxrcIe2Fg8x2hwxj2AFsPtVJVFHAFvSFjdeuoAn7pEjDEpkoB_nqlVvP5PAVhnOpGR1-9xcYLJKkgSa3yZA4475nZptmbMg=w1280-h720-c-rw-v1-e365",
    "https://www.itourvn.com/images/easyblog_articles/751/best-places-to-try-cha-ca.jpg"
  ],
  places: ["Hanoi"]
},
{
  id: 30,
  name: "Bun Bo Nam Bo",
  url: [
    "https://images.eatsmarter.com/sites/default/files/styles/max_size/public/bun-bo-nam-bo-678743.jpg",
    "https://www.bozskyjezbozskyzij.cz/wp-content/uploads/2021/07/bum-bo-nam-bo-scaled.jpg",
    "https://hafoodtours.com/wp-content/uploads/2017/05/bun_bo_nam_bo.jpg"
  ],
  places: ["Ho Chi Minh City"]
},
{
  id: 31,
  name: "Banh Trang Nuong",
  url: [
    "https://cdn.tgdd.vn/Files/2017/03/12/960051/cach-lam-banh-trang-nuong-ngon-cuc-nhanh-voi-chao-chong-dinh-202112282139542041.jpg",
    "https://i.ytimg.com/vi/S7htO6EVF78/maxresdefault.jpg",
    "https://images2.thanhnien.vn/uploaded/tamnm/2021_05_21/banh-trang-nuong-chu-dung-21052021_XDPH.jpg?width=500"
  ],
  places: ["Dalat"]
},
{
  id: 32,
  name: "Com Hen",
  url: [
    "https://upload.wikimedia.org/wikipedia/commons/5/5c/H%E1%BA%BFn_tr%E1%BB%99n.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQBEa2_G5nNSTz3X4p2Bq0MnNWp5aWqYYHFA&usqp=CAU",
    "https://adventurejourney.vn/upload/image/hue-clam-rice.jpg"
  ],
  places: ["Hue"]
},
{
  id: 33,
  name: "Banh Beo",
  url: [
    "https://travinhnetworks.files.wordpress.com/2017/03/banhbeo2b.jpg",
    "https://yummyvietnam.net/wp-content/uploads/2018/08/vietnamese-banh-beo-hue-recipe.jpg",
    "https://www.thatlangon.com/wp-content/uploads/2022/01/12935094_516638465195094_855544683_n.jpg"
  ],
  places: ["Hue"]
},
{
  id: 34,
  name: "Bun Mien Ngan",
  url: [
    "https://i.ytimg.com/vi/11iNN_Uw3eQ/maxresdefault.jpg",
    "https://dep.com.vn/Uploaded/haly/2014_09_10/bun-mien-ngan-deponline7.JPG",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTc_G8bQCGr4K_Ef8i-henH8_Y2b9pBgd9zzfuQL2gIz45DfNeNRi4aQH7BqGYQIikQCbc&usqp=CAU"
  ],
  places: ["Hanoi"]
},
{
  id:35,
  name: "Banh Loc",
  url: [
    "https://cdn.tgdd.vn/2021/10/CookDish/cach-lam-banh-bot-loc-la-chuoi-kieu-hue-dai-mem-trong-veo-cuc-avt-1200x676-1.jpg",
    "https://bepnhamo.vn/wp-content/uploads/2023/02/maxresdefault.jpg",
    "https://www.huongnghiepaau.com/wp-content/uploads/2019/08/banh-bot-loc-duoc-yeu-thich.jpg"
  ],
  places: ["Hue"]
},
{
  id: 36, 
  name: "Bun Bung",
  url: [
    "https://flavorboulevard.com/wp-content/uploads/2010/09/bun-bung.jpg",
    "https://vcdn-giadinh.vnecdn.net/2020/08/22/Bun-bung-hoa-chuoi-1-5678-1598102816.jpg",
    "https://cdn.tgdd.vn/Files/2022/08/16/1456659/tim-hieu-mon-bun-bung-la-mieng-voi-nguyen-lieu-doc-dao-chi-co-o-thai-binh-202208161555041409.jpg"
  ],
  places: ["Hue"]
},
{
  id: 37,
  name: "Goi Ngo Sen",
  url: [
    "https://vietnamesefood.com.vn/pictures/VietnameseFood2/Lotus-stem-salad-with-shrimps.jpg",
    "https://i.ytimg.com/vi/dTAHH5mQAZ0/maxresdefault.jpg",
    "https://live.staticflickr.com/2121/4507045399_dd8fd95caf.jpg"
  ],
  places: ["Mekong Delta"]
},
{
  id: 38, 
  name: "Bun Ca Loc",
  url: [
    "https://cdn.tgdd.vn/2021/03/CookRecipe/Avatar/bun-ca-loc-thumbnail.jpg",
    "https://cdn.pastaxi-manager.onepas.vn/content/uploads/articles/01-le/dac-san-Kien-Giang/cach-nau-bun-ca-loc-kien-giang/Hinh-1-mon-bun-ca-loc-lam-say-dam-thuc-khach-khi-den-voi-kien-giang.jpg",
    "https://haisan.online/wp-content/uploads/2022/11/bun-ca-loc_3.jpg"
  ],
  places: ["Hue"]
},
{
  id: 39,
  name: "Com Ga Hoi An",
  url: [
    "https://statics.vinpearl.com/com-ga-hoi-an-01_1669733755.jpg",
    "https://i.ytimg.com/vi/m4v0TABQgpQ/maxresdefault.jpg",
    "https://vietnamtrips.com/files/photos/article1308/best-hoi-an-chicken-rice-2.jpg"
  ],
  places: ["Hoi An"]
},
{
  id: 40, 
  name: "Bun Bo Xao",
  url: [
    "https://www.cooking-therapy.com/wp-content/uploads/2020/04/Bun-Bo-Xao-7-scaled.jpg",
    "https://ca-times.brightspotcdn.com/dims4/default/361541a/2147483647/strip/false/crop/2048x1365+0+0/resize/1486x990!/quality/80/?url=https%3A%2F%2Fcalifornia-times-brightspot.s3.amazonaws.com%2Fd1%2F08%2Fe58e743c5f0363eee19fa470ce4f%2Fkmjr2lnc-recipe-db",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6G8qu_1dSPDyR4n7VWw7tUeueNrYk61u5tw&usqp=CAU"
  ],
  places: ["Various"]
},
{
  id: 41,
  name: "Hu Tieu Nam Vang",
  url: [
    "https://www.wokandkin.com/wp-content/uploads/2020/04/Hu-Tieu-saved-for-web-500x500.png",
    "https://i0.wp.com/www.wokandkin.com/wp-content/uploads/2020/04/Hu-Tieu-Close-Up-saved-for-web.png?resize=600%2C900&ssl=1",
    "https://i.ytimg.com/vi/fziqSn-xkws/maxresdefault.jpg"
  ],
  places: ["Ho Chi Minh City"]
},
{
  id: 42,
  name: "Bun Mang Vit",
  url: [
    "https://delightfulplate.com/wp-content/uploads/2020/08/Bun-Mang-Vit-Vietnamese-Duck-Vermicelli-Noodle-Soup.jpg",
    "https://images.squarespace-cdn.com/content/v1/52d3fafee4b03c7eaedee15f/1548899966732-WG7RQHEVLX70C50Y9CHW/bun-mang-vit4.jpg",
    "https://tastytouch.net/wp-content/uploads/2022/03/273823594_688246292211642_1887532020210614469_n.png"
  ],
  places: ["Hanoi"]
},
{
  id: 43,
  name: "Banh Gio",
  url: [
    "https://i.ytimg.com/vi/mqNyHPyEKY0/maxresdefault.jpg",
    "https://vietnamesecuisines.com/wp-content/uploads/2022/05/banh-gio-recipe-vietnamese-pork-dumbling-1.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTamroLFac9EAwTfsAOcTbdj3ff8bRupve6xA&usqp=CAU"
  ],
  places: ["Hanoi"]
},
{
  id: 44,
  name: "Goi Xoai",
  url: [
    "https://runawayrice.com/wp-content/uploads/2016/05/Mango-and-Shrimp-Salad-Goi-Xoai-Tom-1024x576.jpg",
    "https://vietnamesecuisines.com/wp-content/uploads/2022/05/Vietnamese-green-mango-salad-with-shrimp-goi-xoai-recipe-2.jpg",
    "https://delightfulplate.com/wp-content/uploads/2022/02/Green-Mango-Salad-with-Seafood-Goi-xoai-xanh-hai-san.jpg"
  ],
  places: ["Mekong Delta"]
},
{
  id: 45,
  name: "Banh Dap",
  url: [
    "https://vietnamtimes.org.vn/stores/news_dataimages/linhdangvnt/062021/12/15/in_article/4501_banh-dap-mon-ngon-dan-da-dat-mien-trung-1-ivivu.jpg?rt=20210612154502",
    "https://indochinavoyages.files.wordpress.com/2016/08/foody-mobile-banh-trang-dap-hoi-an.jpg",
    "https://lh6.googleusercontent.com/YLtxtg6zHgdUAovbuQNbvknhFU5KxXLRNSeO9mxnuMqcsTuBkCpcEs7-7qu9xKGsAkuZCR2bPud6HXCU1LLtcWZGo7cPCZeNy8kiscWKDCoU-H7BbhqCRCnaMORhT3-m8re-qEGD8SVmxmTZT5IxswRdd4R2p1Ghc6RvNUeL-OnWx0dglnMtQScit3HRcA"
  ],
  places: ["Hue"]
},
{
  id: 46,
  name: "Bun Nem Cua Be",
  url: [
    "https://cdn.tgdd.vn/2022/01/CookDish/cach-lam-bun-nem-cua-be-thom-gion-vang-uom-kho-cuong-cuc-don-avt-1200x676.jpg",
    "https://daynauan.info.vn/wp-content/uploads/2016/02/nem-cua-be.jpg",
    "https://i.ytimg.com/vi/IFUqzgCL8_k/maxresdefault.jpg"
  ],
  places: ["Hanoi"]
},
{
  id: 47,
  name: "Banh Uot",
  url: [
    "https://images.food52.com/kGJHjpIcqxMSOrOfzxaM2r_i9Ug=/1200x675/65d94dd2-1509-4e86-9f82-02bc2190de45--Vegan-Banh-Cuon-F52Website.jpg",
    "https://thevietvegan.com/wp-content/uploads/2020/09/IMG_0975W-480x270.jpg",
    "https://images.squarespace-cdn.com/content/v1/52d3fafee4b03c7eaedee15f/0e99e02e-e33d-454c-b7f2-dfd81cc553ad/2023_04_12EOS+M505660.jpg"
  ],
  places: ["Hue"]
},
{
  id: 48,
  name: "Cha Gio",
  url: [
    "https://www.wokandkin.com/wp-content/uploads/2021/03/Cha-Gio-Chay-Close-Up-saved-for-web.png",
    "https://www.wandercooks.com/wp-content/uploads/2019/08/vietnamese-fried-spring-rolls-ig-1.jpg",
    "https://media.30seconds.com/tip/lg/Cha-Gio-Make-Vietnamese-Fried-Spring-Rolls-at-Home-with-Th-51057-19c0856014-1664561983.jpg"
  ],
  places: ["Various"]
}
];



